/**
 * Mixin for Magazine helper methods
 */

const baseMetaMapping = {
    title: { hid: 'title', property: 'title' },
    description: { hid: 'description', property: 'description' },
    robots: { hid: 'robots', property: 'robots' },
    og_locale: { hid: 'og-locale', property: 'og:locale' },
    og_type: { hid: 'og-type', property: 'og:type' },
    og_title: { hid: 'og-title', property: 'og:title' },
    og_description: { hid: 'og-description', property: 'og:description' },
    og_url: { hid: 'og-url', property: 'og:url' },
    og_site_name: { hid: 'og-site_name', property: 'og:site_name' },
    twitter_card: { hid: 'twitter-card', property: 'twitter:card' },
};

const ogImageMapping = {
    og_image: {
        url: { hid: 'og-image', property: 'og:image' },
        width: { hid: 'og-image-width', property: 'og:image:width' },
        height: { hid: 'og-image-height', property: 'og:image:height' },
        type: { hid: 'og-image-type', property: 'og:image:type' },
    },
};

export default {
    data() {
        return {
            baseMetaMapping,
            ogImageMapping,
        };
    },
    methods: {
        generateMeta(metaObject, metaMapping) {
            if (!metaObject) {
                return [];
            }

            const meta = [];

            for (const property in metaMapping) {
                if (property === 'og_image' && metaObject[property]) {
                    for (const subProperty in metaMapping[property]) {
                        const subMapping = metaMapping[property][subProperty];
                        const content = metaObject[property][0][subProperty];

                        if (content) {
                            if (subProperty === 'url') {
                                meta.push({
                                    hid: 'og-image-secure',
                                    property: 'og:image:secure_url',
                                    content,
                                });
                            }

                            meta.push({
                                hid: subMapping.hid,
                                property: subMapping.property,
                                content,
                            });
                        }
                    }
                } else {
                    const mapping = metaMapping[property];
                    let content = metaObject[property];

                    if (property === 'robots' && content) {
                        content = this.formatRobotsTag(content);
                    }

                    if (content) {
                        meta.push({
                            hid: mapping.hid,
                            property: mapping.property,
                            content: typeof content === 'object' ? JSON.stringify(content) : content,
                        });
                    }
                }
            }

            return meta;
        },
        formatRobotsTag(robotsObject) {
            const robotParts = [];

            for (const key in robotsObject) {
                robotParts.push(robotsObject[key]);
            }

            return robotParts.join(', ');
        },
        getPostRoute(postSlug) {
            if (!postSlug) {
                return { name: 'magazine' };
            }

            return {
                name: 'magazine-slug',
                params: {
                    slug: postSlug,
                },
            };
        },
        getCategoryRoute(categorySlug) {
            if (!categorySlug) {
                return { name: 'magazine' };
            }

            return {
                name: 'magazine-category-slug',
                params: {
                    slug: categorySlug,
                },
            };
        },
        getTagRoute(tagSlug) {
            if (!tagSlug) {
                return { name: 'magazine' };
            }

            return {
                name: 'magazine-tag-slug',
                params: {
                    slug: tagSlug,
                },
            };
        },
        getReadingTimeMinutes(readingTimeSec) {
            if (!readingTimeSec) {
                return 0;
            }

            return Math.ceil(readingTimeSec / 60);
        },
    },
};
